import {DeleteButton, StyledChip, StyledContainerChip} from '@components/ui/chip/style.ts'
import {XCloseIcon} from '@components/ui/icon/Icon.tsx'
import {FC, ReactNode} from 'react'

export interface ChipProps {
    text?: string
    textColor?: string
    bgColor?: string
    icon?: ReactNode
    iconPosition?: 'left' | 'right'
    doubleCircle?: boolean
    onDelete?: () => void
}

export const Chip: FC<ChipProps> = ({
    text,
    textColor,
    bgColor,
    icon,
    iconPosition = 'left',
    doubleCircle = false,
    onDelete
}) => {
    return (
        <StyledContainerChip $doubleCircle={doubleCircle}>
            <StyledChip
                $textColor={textColor}
                $bgColor={bgColor}
                $isOnlyIcon={Boolean(!text && icon)}
                $doubleCircle={doubleCircle}
            >
                {iconPosition === 'left' && icon}
                {text && text}
                {iconPosition === 'right' && icon}
                {typeof onDelete === 'function' && (
                    <DeleteButton onClick={onDelete}>
                        <XCloseIcon size={12} />
                    </DeleteButton>
                )}
            </StyledChip>
        </StyledContainerChip>
    )
}
